<template>
    <div>
        <h1 style="font-size: 24px; color: black;">海外日报</h1>
        <div class="block">
            <span>游戏名称：</span>
            <el-select v-model="queryData.gameIds" multiple filterable placeholder="请选择/输入">
                <el-option
                    v-for="item in gameList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <span class="demonstration">日期：</span>
            <el-date-picker
                v-model="queryData.timeDate"
                type="daterange"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
            <el-button type="primary" class="margin-left-10" @click="query">查询</el-button>
            <el-button type="primary" @click="exportExcel()">导出报表</el-button>
        </div>

        <h1>
            <el-table border :data="miniReport"
                      :header-cell-style="{background:'#282828'}"
                      ref="filterTable"
                      @sort-change='sortChange'
                      max-height="820">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="dt" label="日期" sortable='custom'></el-table-column>
                <el-table-column prop="name" label="游戏名称"></el-table-column>
                <el-table-column prop="categoryName" label="分组"></el-table-column>
                <el-table-column prop="subCategoryName" label="二级分组"></el-table-column>
                <el-table-column prop="active" label="活跃" sortable='custom'></el-table-column>
                <el-table-column prop="newUser" label="新增" sortable='custom'></el-table-column>
                <el-table-column prop="r1Rate" label="次留" sortable='custom'></el-table-column>
                <el-table-column prop="avgNum" label="人均游戏个数" sortable='custom'></el-table-column>
                <el-table-column prop="avgTime" label="人均游戏时长" sortable='custom'></el-table-column>
                <el-table-column prop="avgTimes" label="人均游戏频次" sortable='custom'></el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[20,30,50]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
import {downloadData, gameSimpleList, searchMiniReport} from "@/http/api";
import utils from '@/utils'

export default {
    name: "MiniReport",
    data() {
        return {
            gameList: [],
            dialogMaterialVisible: false,
            queryData: {
                gameIds: [],
                timeDate: ['', '']
            },
            queryTrueData: {
                gameIds: [],
                startTime: '',
                endTime: '',
                order: null,
                prop: null
            },
            miniReport: [],
            queryInfo: {
                pagesize: 20,
                pagenum: 1,
                total: 0,
            },
        }
    },
    methods: {
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize;
            this.queryMiniReportList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage;
            this.queryMiniReportList();
        },
        query() {
            this.queryInfo.pagenum = 1;
            this.queryMiniReportList();
        },
        queryMiniReportList() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryTrueData.gameIds = this.queryData.gameIds;
            this.queryTrueData.startTime = this.queryData.timeDate[0];
            this.queryTrueData.endTime = this.queryData.timeDate[1];
            this.queryTrueData.size = this.queryInfo.pagesize;
            this.queryTrueData.page = this.queryInfo.pagenum;
            searchMiniReport(this.queryTrueData).then(resp => {
                this.miniReport = resp.data.info.content;
                this.queryInfo.total = resp.data.info.totalElements;
            });
        },
        exportExcel() {
            let fileName = new Date().toLocaleString() + '海外日报.xlsx';
            downloadData(
                '/mini/reportExcel',
                Object.assign(this.queryTrueData),
                fileName
            )
        },
        sortChange(order) {
            this.queryTrueData.order = order.order;
            this.queryTrueData.prop = order.prop;
            this.queryMiniReportList();
        }
    },
    created() {
        this.queryData.timeDate = [utils.TodayUtil.getToday(), utils.TodayUtil.getToday()];
        gameSimpleList().then(resp => {
            this.gameList = resp.data.info;
        });
        this.queryMiniReportList();
    }
}
</script>

<style scoped>

</style>
